import { Action } from '@ngrx/store';
import {
  AnalyzePaneSettings,
  ConsumptionLoaderConfiguration,
  ConsumptionData,
  AnalyzePeriodData,
  MeterReadingData,
  MeteringPointsFilterData
} from '@model';
import { TemperatureMeteringPoint } from 'app/models/temperature-metering-point.model';
import { MeteringType, AnalyzeSettingsType } from '@enums';

export enum AnalyzeActionTypes {
  AnalyzeLoadConsumptionData = '[analyze] Load main data',
  AnalyzeLoadConsumptionSuccess = '[analyze] Load main success',
  AnalyzeLoadConsumptionFail = '[analyze] Load main fail',

  AnalyzeLoadMeterReadingData = '[analyze] Load meterreading data',
  AnalyzeLoadMeterReadingSuccess = '[analyze] Load meterreading succes',
  AnalyzeLoadMeterReadingFail = '[analyze] Load meterreading fail',

  AnalyzeUpdateSettings = '[analyze] Update Settings',
  AnalyzeUpdatePaneSettings = '[analyze] Update Pane Settings',
  AnalyzeResetHeatData = '[analyze] Reset heat data',
  AnalyzeResetColdData = '[analyze] Reset cold data',
  AnalyzeResetHeatLogicalData = '[analyze] Reset heat Logical data',
  AnalyzeResetColdLogicalData = '[analyze] Reset cold Logical data',
  AnalyzeResetDataOnType = '[analyze] reset data on type',
  AnalyzeUpdatePeriodData = '[analyze] update period data',
  AnalyzeResetPeriodPositions = '[analyze] reset period positions',
  AnalyzeResetPeriodPositionItem = '[analyze] reset period position item',
  AnalyzeResetGraphValues = '[analyze] reset graph values',

  AnalyzeLoadEffectData = '[analyze] Load effect data',
  AnalyzeLoadEffectSuccess = '[analyze] Load effect succes',
  AnalyzeLoadEffectFail = '[analyze] Load effect fail',

  AnalyzeSetMeteringPointsOnHeatData = '[analyze] Set meteringpoints on heat data',
  AnalyzeSetMeteringPointsOnColdData = '[analyze] Set meteringpoints on cold data',
  AnalyzeSetMeteringPointsOnHeatLogicalData = '[analyze] Set meteringpoints on heat Logical data',
  AnalyzeSetMeteringPointsOnColdLogicalData = '[analyze] Set meteringpoints on cold Logical data',

  AnalyzeLoadTemperatureData = '[analyze] Load temperature data',
  AnalyzeLoadTemperatureDataSuccess = '[analyze] Load temperature data success',
  AnalyzeLoadTemperatureDataFail = '[analyze] Load temperature data fail',

  CreateReportKey = '[analyze] Create report key',
  CreateReportKeySuccess = '[analyze] Create report key success',
  CreateReportKeyFail = '[analyze] Create report key fail',

  AnalyzeClearData = '[analyze] Clear data',
  AnalyzeMeteringTabChanged = '[analyze] Metering Tab changed',
  AnalyzeTabChanged = '[analyze] Tab changed'
}

export class AnalyzeLoadConsumptionData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadConsumptionData;
  constructor(public payload: ConsumptionLoaderConfiguration) {}
}
export class AnalyzeLoadConsumptionSuccess implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadConsumptionSuccess;
  constructor(public payload: ConsumptionData) {}
}
export class AnalyzeLoadConsumptionFail implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadConsumptionFail;
  constructor(public payload: any) {}
}

export class AnalyzeUpdatePeriodData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeUpdatePeriodData;
  constructor(public payload: AnalyzePeriodData) {}
}

export class AnalyzeResetPeriodPositions implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetPeriodPositions;
  constructor() {}
}

export class AnalyzeResetPeriodPositionItem implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetPeriodPositionItem;
  constructor(public payload: AnalyzePeriodData) {}
}

export class AnalyzeResetGraphValues implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetGraphValues;
  constructor() {}
}

export class AnalyzeUpdateSettings implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeUpdateSettings;
  constructor(public payload: AnalyzePaneSettings) {}
}

export class AnalyzeUpdatePaneSettings implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeUpdatePaneSettings;
  constructor(public payload: AnalyzePaneSettings) {}
}

export class AnalyzeLoadMeterReadingData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadMeterReadingData;
  constructor(public payload: ConsumptionLoaderConfiguration) {}
}
export class AnalyzeLoadMeterReadingSuccess implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadMeterReadingSuccess;
  constructor(public payload: MeterReadingData) {}
}
export class AnalyzeLoadMeterReadingFail implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadMeterReadingFail;
  constructor(public payload: any) {}
}

export class AnalyzeLoadEffectData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadEffectData;
  constructor(public payload: ConsumptionLoaderConfiguration) {}
}
export class AnalyzeLoadEffectSuccess implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadEffectSuccess;
  constructor(public payload: MeterReadingData) {}
}
export class AnalyzeLoadEffectFail implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadEffectFail;
  constructor(public payload: any) {}
}

export class AnalyzeResetDataOnType implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetDataOnType;
  constructor(public payload: AnalyzePaneSettings) {}
}
export class AnalyzeResetHeatData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetHeatData;
  constructor(public payload: MeteringPointsFilterData) {}
}
export class AnalyzeResetColdData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetColdData;
  constructor(public payload: MeteringPointsFilterData) {}
}
export class AnalyzeResetHeatLogicalData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetHeatLogicalData;
  constructor(public payload: MeteringPointsFilterData) {}
}
export class AnalyzeResetColdLogicalData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeResetColdLogicalData;
  constructor(public payload: MeteringPointsFilterData) {}
}

export class AnalyzeSetMeteringPointsOnHeatData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeSetMeteringPointsOnHeatData;
  constructor(public payload: MeteringPointsFilterData) {}
}
export class AnalyzeSetMeteringPointsOnColdData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeSetMeteringPointsOnColdData;
  constructor(public payload: MeteringPointsFilterData) {}
}

export class AnalyzeSetMeteringPointsOnHeatLogicalData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeSetMeteringPointsOnHeatLogicalData;
  constructor(public payload: MeteringPointsFilterData) {}
}
export class AnalyzeSetMeteringPointsOnColdLogicalData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeSetMeteringPointsOnColdLogicalData;
  constructor(public payload: MeteringPointsFilterData) {}
}

export class AnalyzeLoadTemperatureData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadTemperatureData;
  constructor(public payload: MeteringPointsFilterData) {}
}
export class AnalyzeLoadTemperatureDataSuccess implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadTemperatureDataSuccess;
  constructor(public payload: TemperatureMeteringPoint[]) {}
}
export class AnalyzeLoadTemperatureDataFail implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeLoadTemperatureDataFail;
  constructor(public payload: any) {}
}
export class CreateReportKey implements Action {
  readonly type = AnalyzeActionTypes.CreateReportKey;
  constructor() {}
}
export class CreateReportKeySuccess implements Action {
  readonly type = AnalyzeActionTypes.CreateReportKeySuccess;
  constructor(public payload: string) {}
}
export class CreateReportKeyFail implements Action {
  readonly type = AnalyzeActionTypes.CreateReportKeyFail;
  constructor(public payload: any) {}
}
export class AnalyzeClearData implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeClearData;
}
export class AnalyzeMeteringTabChanged implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeMeteringTabChanged;
  constructor(public payload: MeteringType) {}
}
export class AnalyzeTabChanged implements Action {
  readonly type = AnalyzeActionTypes.AnalyzeTabChanged;
  constructor(public payload: AnalyzeSettingsType) {}
}
export type AnalyzeActions =
  | AnalyzeLoadConsumptionData
  | AnalyzeLoadConsumptionSuccess
  | AnalyzeLoadConsumptionFail
  | AnalyzeUpdateSettings
  | AnalyzeResetColdData
  | AnalyzeResetHeatData
  | AnalyzeResetHeatLogicalData
  | AnalyzeResetColdLogicalData
  | AnalyzeResetDataOnType
  | AnalyzeUpdatePeriodData
  | AnalyzeResetPeriodPositions
  | AnalyzeResetPeriodPositionItem
  | AnalyzeResetGraphValues
  | AnalyzeLoadMeterReadingData
  | AnalyzeLoadMeterReadingSuccess
  | AnalyzeLoadMeterReadingFail
  | AnalyzeLoadEffectData
  | AnalyzeLoadEffectFail
  | AnalyzeLoadEffectFail
  | AnalyzeSetMeteringPointsOnHeatData
  | AnalyzeSetMeteringPointsOnColdData
  | AnalyzeSetMeteringPointsOnHeatLogicalData
  | AnalyzeSetMeteringPointsOnColdLogicalData
  | AnalyzeLoadTemperatureData
  | AnalyzeLoadTemperatureDataSuccess
  | AnalyzeLoadTemperatureDataFail
  | CreateReportKey
  | CreateReportKeySuccess
  | CreateReportKeyFail
  | AnalyzeClearData
  | AnalyzeMeteringTabChanged
  | AnalyzeTabChanged
  | AnalyzeUpdatePaneSettings;
